import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config.service';
import { InvestmentReversalResponse, LoanList } from '../../../model/finzy-flex/loan-list.model';
import { SignedDocuments, SignedDocumentType } from '../../../model/finzy-flex/signed-document.model';

@Injectable()
export class LoanService {
    private readonly httpClient: HttpClient;
	private readonly configService: ConfigService;
    constructor(httpClient: HttpClient, configService: ConfigService) {
		this.httpClient = httpClient;
		this.configService = configService;
	}

    public getLoansList(entity: string, entityId: string, pageSize?: number, page?: number, loanShortId?: string, productCodes?: string, investmentStartDate?: Date, investmentEndDate?: Date, sort?: string): Promise<LoanList> {
		let params = {};
		if (pageSize) {
			params['size'] = pageSize;
		}
		if (page) {
			params['page'] = page;
		}
		if (loanShortId) {
			params['loanShortId'] =  loanShortId;
		}
		if (productCodes) {
			params['productCodes'] = productCodes;
		}
		if (investmentStartDate) {
			params['investmentStartDate'] = investmentStartDate;
		}
		if (investmentEndDate) {
			params['investmentEndDate'] = investmentEndDate;
		}
		if (sort) {
			params['sort'] = sort;
		}
		const url = `${this.configService.getLoanService_V2_Url()}/${entity}/${entityId}/loans`;
		return this.httpClient.get<LoanList>(url, {params: params}).toPromise();
	}

	public async investmentReversal(portfolioId: string, loanId: string): Promise<InvestmentReversalResponse> {
        const url = `${this.configService.getLoanService_V2_Url()}/lender/reverse/${portfolioId}/${loanId}`;
        return await this.httpClient.delete<InvestmentReversalResponse>(url).toPromise();
    }

	public async getSignedDocument(loanId: string, documentType: SignedDocumentType): Promise<SignedDocuments> {
		const url = `${this.configService.getLoanService_V2_Url()}/loan/${loanId}/${documentType}`;
		return await this.httpClient.get<SignedDocuments>(url).toPromise();
	}

	public async getConsolidatedSignedDocument(loanId: string): Promise<any> {
		const url = `${ConfigService.getBaseUrl()}/loan-assignment-schedule/${loanId}/consolidated-loan-agreement/download`;
		return await this.httpClient.get(url, {responseType: 'blob'}).toPromise();
	}
}